var LogStatus;
(function (LogStatus) {
    LogStatus[LogStatus["REQUESTED"] = 0] = "REQUESTED";
    LogStatus[LogStatus["RUNNING"] = 1] = "RUNNING";
    LogStatus[LogStatus["FAILED"] = 2] = "FAILED";
    LogStatus[LogStatus["READY"] = 3] = "READY";
    LogStatus[LogStatus["DOWNLOADED"] = 4] = "DOWNLOADED";
})(LogStatus || (LogStatus = {}));
export default LogStatus;
//# sourceMappingURL=LogStatus.js.map